// extracted by mini-css-extract-plugin
export default {"search":"DropdownWithSearch_search__Xf40r"};